export default "__VITE_ASSET__COJTUYjD__"